export const FacePlusIcon = ({ className = '' }: { className?: string }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M8.6 14.53C8.27 14.58 7.94 14.6 7.6 14.6C3.73 14.6 0.6 11.47 0.6 7.6C0.6 3.73 3.73 0.6 7.6 0.6C11.47 0.6 14.6 3.73 14.6 7.6C14.6 7.94 14.58 8.27 14.53 8.6"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M7.6 11.6C6.01 11.6 4.68 10.55 4.25 9.1"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M12.1 14.6V9.6"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M9.6 12.1H14.6"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M10.6 6.1C10.6 6.38 10.38 6.6 10.1 6.6C9.82 6.6 9.6 6.38 9.6 6.1C9.6 5.82 9.82 5.6 10.1 5.6C10.38 5.6 10.6 5.82 10.6 6.1Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeMiterlimit="10"
      />
      <path
        d="M5.6 6.1C5.6 6.38 5.38 6.6 5.1 6.6C4.82 6.6 4.6 6.38 4.6 6.1C4.6 5.82 4.82 5.6 5.1 5.6C5.38 5.6 5.6 5.82 5.6 6.1Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeMiterlimit="10"
      />
    </svg>
  )
}
